import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@justonweb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Banner } from '../app/models/banner.model';

@Injectable({providedIn: 'root'})
export class BannerFacade {

    constructor(
        private httpClient: HttpClient,
        private appConfig: AppConfigService
    ) { }

    getMessages(type: 'REGBP_B1' | 'REGBP_B2', language: string): Observable<string[]> {
        return this.httpClient.get<{values: Banner[]}>(this.appConfig.getConfig().baseUrl + '/banner?bannertype=' + type)
                .pipe(
                    map(r => r?.values),
                    map((banners: Banner[]) => {
                        switch (language) {
                            case 'nl':
                                return banners?.find(b => b?.language === 'N')?.messages?.map(m => m?.bannerText);
                            case 'fr':
                                return banners?.find(b => b?.language === 'F')?.messages?.map(m => m?.bannerText);
                            case 'de':
                                return banners?.find(b => b?.language === 'D')?.messages?.map(m => m?.bannerText);
                            default:
                                return;
                        }
                    })
                );
    }

}
